import { styled } from "@linaria/react"

import * as textStyles from "@/styles/textStyles.ts"

import type { DiffLineType } from "@/lib/client/generated/TypeDefinitions.ts"


export const LineCharComponent = (props: {
  type?: DiffLineType | null
}) => {
  return (
    <LineChar>
      {getInlineDiffLineChar(props.type || null)}
    </LineChar>
  )
}

function getInlineDiffLineChar(type: DiffLineType | null): string {
  if (type === "ADDED") {
    return "+"
  }

  if (type === "DELETED") {
    return "\u2212"
  }

  if (type === "MODIFIED") {
    return "*"
  }

  if (type === "CONFLICT_OLD") {
    return "<"
  }

  if (type === "CONFLICT_NEW") {
    return ">"
  }

  return "\u00a0"
}

const LineChar = styled.span`
  ${textStyles.monospaceFont};

  margin: 0 4px;

  user-select: none;
`
